var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgCircledWarning = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 8.138C11 7.51 11.43 7 11.96 7s.96.51.96 1.138v6.83c0 .629-.43 1.139-.96 1.139s-.96-.51-.96-1.139v-6.83zM11.96 17c-.53 0-.96.51-.96 1.138 0 .629.43 1.139.96 1.139s.96-.51.96-1.139c0-.628-.43-1.138-.96-1.138z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M9.296 1.73c1.195-2.307 4.213-2.307 5.408 0l8.881 17.133C24.772 21.152 23.272 24 20.881 24H3.119C.728 24-.77 21.152.415 18.863L9.295 1.73zM12.9 2.765c-.399-.778-1.404-.778-1.802 0L2.225 20.087c-.395.771.104 1.731.9 1.731h17.749c.797 0 1.296-.96.9-1.731L12.902 2.765z"
}))));
export default SvgCircledWarning;